import React, { useState } from "react";
import PublicLayout from "../components/PublicLayout";
import Login from "../components/Login";
import Register from "../components/Register";
import Modal from "../components/Modal";
import { FaUsers, FaMoneyBillWave, FaCameraRetro } from "react-icons/fa";

const LandingPage = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);

  return (
    <PublicLayout>
      <div className="w-full max-w-7xl mx-auto space-y-16 px-4 sm:px-6 lg:px-8">
        <section className="text-center space-y-6">
          <h1 className="text-3xl sm:text-5xl font-extrabold text-primary">TripsFlare — Your Trip, Shared.</h1>
          <p className="text-base sm:text-xl text-gray-700 max-w-2xl mx-auto">
            Simplify travel planning. Invite friends, split costs, and create unforgettable memories.
          </p>
          <div className="flex flex-col sm:flex-row sm:justify-center gap-4">
            <button
              onClick={() => setShowRegister(true)}
              className="btn-full bg-secondary text-white px-6 py-3 rounded-lg hover:bg-green-700 transition"
            >
              Get Started Free
            </button>
            <button
              onClick={() => setShowLogin(true)}
              className="btn-full border border-primary text-primary px-6 py-3 rounded-lg hover:bg-primary hover:text-white transition"
            >
              Login
            </button>
          </div>
        </section>

        <section className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 text-center">
          <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
            <FaUsers className="text-4xl text-primary mb-4 mx-auto" />
            <h3 className="text-xl font-bold mb-2">Plan Together</h3>
            <p className="text-gray-600">Invite friends, manage subtrips, and assign responsibilities with ease.</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
            <FaMoneyBillWave className="text-4xl text-primary mb-4 mx-auto" />
            <h3 className="text-xl font-bold mb-2">Track Expenses</h3>
            <p className="text-gray-600">Split costs transparently and avoid awkward money talks.</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
            <FaCameraRetro className="text-4xl text-primary mb-4 mx-auto" />
            <h3 className="text-xl font-bold mb-2">Share Memories</h3>
            <p className="text-gray-600">Add notes, photos, and plans to relive the journey anytime.</p>
          </div>
        </section>

        {/* Modals */}
        <Modal isOpen={showLogin} onClose={() => setShowLogin(false)}>
          <Login
            onClose={() => setShowLogin(false)}
            onSwitch={() => {
              setShowLogin(false);
              setShowRegister(true);
            }}
          />
        </Modal>

        <Modal isOpen={showRegister} onClose={() => setShowRegister(false)}>
          <Register
            onClose={() => setShowRegister(false)}
            onSwitch={() => {
              setShowRegister(false);
              setShowLogin(true);
            }}
          />
        </Modal>

        <footer className="text-center text-sm text-gray-500 mt-8">
          &copy; {new Date().getFullYear()} TripsFlare. All rights reserved.
        </footer>
      </div>
    </PublicLayout>
  );
};

export default LandingPage;
